import { IdCard } from 'lucide-react';
import { crmGet } from '../../api/api';
import LiveDashboardPage from './LiveDashboardPage';

export default function CRMDashboardPage() {
  return <LiveDashboardPage title="CRM" description="Customer Relationship Management" icon={IdCard} getData={crmGet} />;
}